import { useEffect, useState, useCallback } from 'react';
import { SuperAdminSidebar } from '../../components/Sidebar';
import api from '../../utils/api';

const STATUS = {
  up: { label: 'Online', color: '#16a34a', bg: 'rgba(22,163,74,0.12)' },
  down: { label: 'Offline', color: '#dc2626', bg: 'rgba(220,38,38,0.12)' },
  unknown: { label: 'Unbekannt', color: '#9ca3af', bg: 'rgba(156,163,175,0.12)' },
};

export default function Uptime() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    api.get('/superadmin/uptime').then(r => setData(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, [load]);

  const targets = data?.targets || [];
  const incidents = data?.incidents || [];

  return (
    <div style={{ display: 'flex' }}>
      <SuperAdminSidebar />
      <main className="main-content">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
          <div>
            <h1 style={{ fontSize: 26 }}>Uptime &amp; Status</h1>
            <p style={{ color: 'var(--text3)', fontSize: 13 }}>
              Überwachung von Server, Datenbank und Website · Prüfung alle {data?.checkedEvery || 60}s
            </p>
          </div>
          <button className="btn btn-ghost btn-sm" onClick={load}>Aktualisieren</button>
        </div>

        {loading ? <p style={{ color: 'var(--text3)' }}>Wird geladen…</p> : (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16, marginBottom: 28 }}>
              {targets.map(t => {
                const s = STATUS[t.status] || STATUS.unknown;
                return (
                  <div key={t.key} className="card" style={{ borderLeft: `4px solid ${s.color}` }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <h3 style={{ fontSize: 15 }}>{t.name}</h3>
                      <span style={{ fontSize: 12, fontWeight: 700, color: s.color, background: s.bg, padding: '3px 10px', borderRadius: 20 }}>{s.label}</span>
                    </div>
                    <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 10, lineHeight: 1.7 }}>
                      <div>Antwortzeit: <b style={{ color: 'var(--text)' }}>{t.latency != null ? t.latency + ' ms' : '—'}</b></div>
                      <div>Zuletzt geprüft: {t.lastChecked ? new Date(t.lastChecked).toLocaleTimeString('de-CH') : '—'}</div>
                      {t.status !== 'up' && t.error && <div style={{ color: s.color }}>Fehler: {t.error}</div>}
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="card">
              <h3 style={{ fontSize: 14, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 14 }}>
                Vorfälle (letzte 24 h)
              </h3>
              {incidents.length === 0 ? (
                <p style={{ color: 'var(--text3)', fontSize: 13 }}>Keine Statusänderungen in den letzten 24 Stunden.</p>
              ) : (
                <div className="table-wrap">
                  <table>
                    <thead><tr><th>Ziel</th><th>Status</th><th>Antwortzeit</th><th>Fehler</th><th>Zeit</th></tr></thead>
                    <tbody>
                      {incidents.map((e, i) => {
                        const s = STATUS[e.status] || STATUS.unknown;
                        return (
                          <tr key={i}>
                            <td>{targets.find(t => t.key === e.target)?.name || e.target}</td>
                            <td><span style={{ color: s.color, fontWeight: 700 }}>{s.label}</span></td>
                            <td>{e.latency_ms != null ? e.latency_ms + ' ms' : '—'}</td>
                            <td style={{ color: 'var(--text3)', fontSize: 12 }}>{e.error || '—'}</td>
                            <td style={{ color: 'var(--text3)', fontSize: 12 }}>{new Date(e.created_at).toLocaleString('de-CH')}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </>
        )}
      </main>
    </div>
  );
}
